var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ActionButton, Callout, DefaultButton, FontIcon, hiddenContentStyle, mergeStyles, Separator, Stack } from "@fluentui/react";
import { useId } from "@fluentui/react-hooks";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { FooterControl } from "./components/FooterControl";
import { HeaderControl } from "./components/HeaderControl";
import { Text } from "./components/texts/Text";
import { copyProps, getPageProps } from "./utils/common";
import { formatDate } from "./utils/stringUtils";
import { useClasses } from "./utils/useClasses";
import { useHashimukhTheme } from "./utils/useHashimukhTheme";
import { useMediaQuery } from "./utils/useMediaQuery";
var headerHost = "header";
var footerHost = "footer";
var tokens = {
    container: {
        childrenGap: 20,
    }
};
export var HashimukhPage = function (props) {
    var _a, _b, _c, _d;
    var theme = useHashimukhTheme();
    var pageProps = getPageProps(props.pageType);
    var hasBackgroundImage = props.background ? true : false;
    var showBgImage = useMediaQuery("(min-width: " + pageProps.width + ")");
    var aboutBg = (_b = (_a = props.background) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.about;
    var aboutButtonId = useId("btn-about-img");
    var aboutLabelId = useId("label-about_img");
    var aboutDescriptionId = useId("dscrp_about_img");
    var _e = useState(false), showAboutImage = _e[0], setShowAboutImage = _e[1];
    var showContent = !showAboutImage;
    var prefixBgImage = showContent ? "linear-gradient(0deg, " + theme.palette.blackTranslucent40 + ", " + theme.palette.blackTranslucent40 + "), " : "";
    var sidePadding = Math.min(56, ((window.screen.width / 100) * 7));
    var styles = {
        root: {
            root: {
                height: '100%',
                minHeight: "100vh",
                backgroundImage: showBgImage && hasBackgroundImage
                    ? prefixBgImage + "url(" + ((_c = props.background) === null || _c === void 0 ? void 0 : _c.url) + ")"
                    : undefined,
                backgroundSize: 'cover',
                backgroundAttachment: 'fixed',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }
        },
        container: {
            root: {
                maxWidth: hasBackgroundImage ? pageProps.width : "100%",
                width: "100%",
                backgroundColor: theme.palette.white,
            }
        },
        body: {
            root: {
                width: "100%",
                maxWidth: pageProps.width,
                paddingLeft: sidePadding,
                paddingRight: sidePadding,
            }
        },
        headerWrapper: {
            root: {
                width: "100%",
            }
        },
        headerContainer: {
            root: {
                width: '100%',
            }
        },
        header: {
            paddingLeft: sidePadding,
            paddingRight: sidePadding,
            paddingTop: 16,
            paddingBottom: 16,
        },
        footerWrapper: {
            root: {
                width: "100%",
            }
        },
        footerContainer: {
            root: {
                width: '100%',
            }
        },
        footer: {
            paddingLeft: sidePadding,
            paddingRight: sidePadding,
        },
        aboutBgButtonContainer: {
            root: {
                float: "right",
                margin: "16px",
                position: "fixed",
                right: "16px",
                bottom: "4px",
            }
        },
        aboutBgButton: {
            root: {}
        },
        aboutBgDialog: {
            root: {
                paddingTop: "20px",
                paddingBottom: "20px",
                paddingRight: "24px",
                paddingLeft: "24px",
                width: 350
            }
        }
    };
    var classes = useClasses(function () { return ({
        container: showContent ? { minHeight: "100vh" } : hiddenContentStyle,
        aboutIcons: mergeStyles({
            marginRight: 4
        }),
    }); });
    var forwardProps = copyProps(props, {});
    delete forwardProps.styles;
    delete forwardProps.tokens;
    return _jsxs(Stack, __assign({ id: "hsm-page-root", className: mergeStyles(styles.root.root, props.styles) }, forwardProps, { horizontal: true }, { children: [props.metas && _jsxs(Helmet, { children: [_jsx("title", { children: props.metas.title }, void 0), _jsx("meta", { name: "description", content: props.metas.description }, void 0), _jsx("meta", { itemProp: "name", content: props.metas.title }, void 0), _jsx("meta", { itemProp: "description", content: props.metas.description }, void 0), props.background && _jsx("meta", { itemProp: "image", content: props.background.url }, void 0), _jsx("meta", { property: "og:url", content: location.href }, void 0), _jsx("meta", { property: "og:type", content: "website" }, void 0), _jsx("meta", { property: "og:title", content: props.metas.title }, void 0), _jsx("meta", { property: "og:description", content: props.metas.description }, void 0), props.background && _jsx("meta", { property: "og:image", content: props.background.url }, void 0), _jsx("meta", { name: "twitter:card", content: "summary_large_image" }, void 0), _jsx("meta", { name: "twitter:title", content: props.metas.title }, void 0), _jsx("meta", { name: "twitter:description", content: props.metas.description }, void 0), props.background && _jsx("meta", { name: "twitter:image", content: props.background.url }, void 0)] }, void 0), _jsxs(Stack, __assign({ id: "hsm-page-container", className: classes.container, styles: styles.container, tokens: tokens.container, horizontalAlign: "center" }, { children: [_jsxs(Stack, __assign({ id: "hsm-page-header-wrapper", styles: styles.headerWrapper, horizontalAlign: "center" }, { children: [_jsx(Stack, { id: headerHost, styles: styles.headerContainer }, void 0), _jsx(HeaderControl, { hostId: headerHost, title: props.heading ? props.heading : "Hashimukh Foundation", subTitle: props.subHeading, contentClass: styles.header, horizontalAlign: "center", type: props.pageType, accessories: props.accesories }, void 0)] }), void 0), _jsx(Stack, __assign({ id: "hsm-page-body", styles: styles.body, tokens: props.tokens }, { children: props.children }), void 0), _jsxs(Stack, __assign({ id: "hsm-page-footer-wrapper", styles: styles.footerWrapper, horizontalAlign: "center", verticalFill: true, verticalAlign: "end" }, { children: [_jsx(Stack, { id: footerHost, styles: styles.footerContainer }, void 0), _jsx(FooterControl, { hostId: footerHost, contentClass: styles.footer, horizontalAlign: "center", type: props.pageType }, void 0)] }), void 0)] }), void 0), ((_d = styles.root.root) === null || _d === void 0 ? void 0 : _d["backgroundImage"]) &&
                _jsxs(Stack, __assign({ styles: styles.aboutBgButtonContainer, horizontalAlign: "end", verticalAlign: "end" }, { children: [_jsx(DefaultButton, { id: aboutButtonId, text: "Picture", iconProps: { iconName: "Info" }, styles: styles.aboutBgButton, checked: showAboutImage, onClick: function () { return (setShowAboutImage(!showAboutImage)); } }, void 0), _jsx(Callout, __assign({ styles: styles.aboutBgDialog, "aria-labelledby": aboutLabelId, ariaDescribedBy: aboutDescriptionId, target: "#" + aboutButtonId, role: "dialog", hidden: !showAboutImage, gapSpace: 4, isBeakVisible: true, onDismiss: function () { return setShowAboutImage(false); } }, { children: aboutBg
                                ? _jsxs(Stack, { children: [aboutBg.short && _jsx(Text, __assign({ type: "h1" }, { children: aboutBg.short }), void 0), _jsxs(Text, __assign({ type: "normal" }, { children: [_jsx(FontIcon, { className: classes.aboutIcons, "aria-label": "Date taken", iconName: "DateTime" }, void 0), " ", aboutBg.date_taken ? formatDate(new Date(aboutBg.date_taken)) : "Unknown"] }), void 0), _jsxs(Text, __assign({ type: "normal" }, { children: [_jsx(FontIcon, { className: classes.aboutIcons, "aria-label": "Place", iconName: "MapPin" }, void 0), " ", aboutBg.place ? aboutBg.place : "Unknown"] }), void 0), aboutBg.description &&
                                            _jsxs(_Fragment, { children: [_jsx(Separator, {}, void 0), _jsx(Text, __assign({ type: "normal" }, { children: aboutBg.description }), void 0)] }, void 0), _jsx(Separator, {}, void 0), _jsx(Stack, __assign({ horizontal: true }, { children: aboutBg.more && _jsx(ActionButton, { href: aboutBg.more, target: "__blank", iconProps: { iconName: "OpenInNewTab" }, text: "Learn more" }, void 0) }), void 0)] }, void 0)
                                : _jsx(Stack, __assign({ verticalAlign: "center", horizontalAlign: "center" }, { children: _jsx(Text, { children: "Information about this image is not available right now." }, void 0) }), void 0) }), void 0)] }), void 0)] }), void 0);
};
//# sourceMappingURL=HashimukhPage.js.map